import { AnimatedStats as AnimatedStatsUI } from "@carfax/web-ui/components/AnimatedStats";
import { Container } from "@carfax/web-ui/elements/Container";
import { ModuleAnimatedStats } from "@carfax/contentful/PageModularModule";
import { useTranslations } from "next-intl";

interface AnimatedStatsProps {
  module?: ModuleAnimatedStats;
}

export const AnimatedStats = ({ module }: AnimatedStatsProps = {}) => {
  const t = useTranslations("preview-report");

  const props = module || {
    tagline: t("animatedStats.tagline"),
    stat1Value: 45,
    stat1Suffix: t("animatedStats.stat1Suffix"),
    stat1Label: t("animatedStats.stat1Label"),
    stat2Value: 40,
    stat2Suffix: t("animatedStats.stat2Suffix"),
    stat2Label: t("animatedStats.stat2Label"),
    stat3Value: 30,
    stat3Suffix: t("animatedStats.stat3Suffix"),
    stat3Label: t("animatedStats.stat3Label"),
    imageUrl: "/static/preview-report/car-fox-leaning.png",
    imageAlt: "",
  };

  return (
    <Container>
      <AnimatedStatsUI {...props} />
    </Container>
  );
};
